import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import { useCityRecord } from "@/app/Cities/Cities/Hooks/useCityRecord";

import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { ArrowLeftRightIcon } from "lucide-react";

export function CityRecordScreen() {
  const city = useCityRecord();

  return (
    <RecordScreen
      tabParams={{ id: city.id }}
      title={city.name}
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/cities/$id",
          Icon: DocumentTextIcon,
        },
        {
          name: "Trips",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/cities/$id/trips",
          Icon: ArrowLeftRightIcon,
        },
      ]}
    />
  );
}
